import React, { Component } from "react";
import { Tabs, Tab, Breadcrumb } from "react-bootstrap";
import ReportGeneralTable from "./ReportGeneralTable";
import PurchaseOrderDoc from "../po/PurchaseOrderDoc";
import ReportStore from "../../stores/ReportStore";
// import ReportShopPurchaseOrder from './ReportShopPurchaseOrder'
import StockTransactionReport from "../stock/StockTransactionReport";
import MechanicWaitPartReport from "../po/MechanicWaitPartReport";
import StockStore from "../../stores/StockStore";
import FontAwesome from "react-fontawesome";
import Moment from "moment";
// import withSizes from 'react-sizes'
import { connect } from "react-redux";
const MONTH = Moment().format("MM");

class ReportPurchaseOrderPage extends Component {
  constructor(...args) {
    super(...args);

    const yTh = parseInt(Moment().format("YYYY")) + 543;
    const optionsYear = [];

    for (var i = yTh; i >= 2557; i--) {
      optionsYear.push({
        value: i,
        label: i,
      });
    }
    let { messages } = this.props;
    const optionsMonth = [
      { value: 0, label: messages["All Year"] },
      { value: "01", label: messages["January"] },
      { value: "02", label: messages["February"] },
      { value: "03", label: messages["March"] },
      { value: "04", label: messages["April"] },
      { value: "05", label: messages["May"] },
      { value: "06", label: messages["June"] },
      { value: "07", label: messages["July"] },
      { value: "08", label: messages["August"] },
      { value: "09", label: messages["September"] },
      { value: "10", label: messages["October"] },
      { value: "11", label: messages["November"] },
      { value: "12", label: messages["December"] },
    ];

    this.state = {
      showTable: true,
      activeTab: 1,
      data: [],
      length: 10,
      totalPage: 0,
      loading: false,
      optionsYear: optionsYear,
      optionsMonth: optionsMonth,
      defaultMonth: 0,
      defaultYear: yTh,
      type: "any",
      record_type: "request_purchase",
      showClose: false,
      loadClose: false,
      poNo: "",
      docClose: false,
      docClose2: false,
      showTran: false,
    };
  }

  componentDidMount() {
    // let {type,defaultYear,defaultMonth,record_type} = this.state
    let { activeTab } = this.state;
    // this.loadStockTransaction(type,defaultYear-543,defaultMonth,record_type,0,10)
    if (this.props.initPoNo !== "") {
      this.onPOClick(this.props.initPoNo);
      this.setState({ poNo: this.props.initPoNo });
    }
    if (this.props.showPO) activeTab = 1;
    else if (this.props.showPOWaiting) activeTab = 6;
    else if (this.props.showPRWaiting) {
      activeTab = 4;
      this.setState({ showTran: true });
    } else if (this.props.showMechanicWaiting) activeTab = 5;

    this.setState({ activeTab: activeTab }, () => {
      if (activeTab === 6 || activeTab === 5) this.onTabsSelect(activeTab);
    });
  }

  componentWillReceiveProps(newProps) {
    if (
      newProps.shop_id != undefined &&
      newProps.shop_id != "" &&
      newProps.show &&
      newProps.show !== this.props.show
    )
      this.refs.poTable.loadData(
        this.state.defaultYear,
        MONTH,
        "00",
        "shop_id",
        newProps.shop_id,
        0,
        13,
        true
      );
  }

  getNumberFormat(value) {
    let _val =
      value === "" || value === null || value === undefined || isNaN(value)
        ? 0
        : value;
    _val = parseFloat(_val);
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
  }

  loadStockTransaction(
    type = "",
    year = "",
    month = 0,
    record_type = "",
    start = 0,
    length = 10
  ) {
    let that = this;
    this.setState({ loading: true, totalPage: 0 });
    StockStore.loadStockTransaction(
      type,
      year,
      month,
      this.state.record_type,
      start,
      this.state.length,
      "",
      "1",
      function (result) {
        const totalPage = result.total_count / 10;
        that.setState({
          data: result.data,
          loading: false,
          totalPage: Math.ceil(totalPage),
        });
      }
    );
  }

  renameDoc(newPoNo) {
    this.refs.poDoc.getWrappedInstance().renameDoc(newPoNo);

    this.setState({ poNo: newPoNo });
  }

  showTable() {
    this.setState({ showTable: true, showClose: true, loadClose: true });
    // this.loadData(this.state.defaultYear,MONTH,'00','purchase_order_no','',0,13,false)
    if (this.props.onTableShow !== undefined) {
      this.props.onTableShow();
    }
  }

  onRowSelect(item) {
    let { mode } = this.props;
    if (mode === "modal") this.props.onSelectPO(item);
    else {
      this.onPOClick(item.purchase_order_no);
      this.setState({ poNo: item.purchase_order_no });
    }
  }

  onPOClick(purchase_order_no) {
    if (purchase_order_no != "") {
      let { activeTab } = this.state;
      if (activeTab === 1) this.setState({ docClose: false });
      else if (activeTab === 6) this.setState({ docClose2: false });
      this.setState({ showTable: false, showClose: false, loadClose: false });
      this.refs.poDoc.getWrappedInstance().loadData(purchase_order_no);
      if (this.props.onDocShow !== undefined) {
        this.props.onDocShow(purchase_order_no);
      }
      this.setState({ poNo: purchase_order_no });
    }
  }

  onDocNew(recordid) {
    let { activeTab } = this.state;
    if (activeTab === 1) this.setState({ docClose: false });
    else if (activeTab === 6) this.setState({ docClose2: false });
    this.setState({ showTable: false });
    this.refs.poDoc.getWrappedInstance().loadNewDoc(recordid, (item) => {
      if (this.props.onDocShow !== undefined) {
        this.props.onDocShow(item.purchase_order_no);
        this.setState({ poNo: item.purchase_order_no });
      }
    });
  }

  renderStatus(status, row) {
    let { messages } = this.props;
    let result = <span></span>;
    let payment = <span></span>;
    if (row.payment_date != "") {
      payment = (
        <span className="label label-success" data-value="3">
          <FontAwesome name="money" />
          &nbsp;ชำระเงินแล้ว
        </span>
      );
    }
    if (row.status == 0) {
      result = (
        <div>
          <span className="label label-default" data-value="0">
            {messages["Start"]}
          </span>{" "}
          {payment}
        </div>
      );
    } else if (row.status == 1) {
      result = (
        <div>
          <span className="label label-primary" data-value="1">
            {messages["Approved"]}
          </span>{" "}
          {payment}
        </div>
      );
    } else if (row.status == 2) {
      result = (
        <div>
          <span className="label label-primary" data-value="2">
            {messages["Received"]}
          </span>{" "}
          {payment}
        </div>
      );
    } else if (row.status == 3) {
      result = (
        <div>
          <span className="label label-success" data-value="3">
            {messages["Imported"]}
          </span>{" "}
          {payment}
        </div>
      );
    } else if (row.status == 4) {
      result = (
        <div>
          <span className="label label-success" data-value="4">
            {messages["Repaired"]}
          </span>{" "}
          {payment}
        </div>
      );
    } else if (row.status == 6) {
      result = (
        <div>
          <span className="label label-danger" data-value="6">
            {messages["Not Approval"]}
          </span>{" "}
          {payment}
        </div>
      );
    } else {
      result = (
        <div>
          <span></span> {payment}
        </div>
      );
    }

    return result;
  }

  onRenderColumn(data, col, row) {
    if (col === 9) {
      return this.renderStatus(data, row);
    } else if (col === 7) {
      return <span style={{ color: data < 0 ? "red" : "" }}>{data}</span>;
    } else {
      return <span>{data}</span>;
    }
  }

  onDocClose() {
    let { activeTab } = this.state;
    if (activeTab === 1) this.setState({ docClose: true });
    else if (activeTab === 6) this.setState({ docClose2: true });
    else if (activeTab === 4) {
      this.setState({ showTran: false }, () => {
        this.setState({ showTran: true });
      });
    }
    this.showTable();
  }

  loadData(
    year,
    month,
    day,
    searchBy,
    query,
    activePage,
    itemPerPage,
    is_match,
    callback
  ) {
    ReportStore.loadPurchaseOrderList(
      year,
      month,
      day,
      searchBy,
      query,
      activePage * itemPerPage,
      itemPerPage,
      is_match,
      callback
    );
  }

  loadDataRange(
    start,
    end,
    searchBy,
    query,
    activePage,
    itemPerPage,
    callback
  ) {
    ReportStore.loadPurchaseOrderListRange(
      start,
      end,
      searchBy,
      query,
      activePage * itemPerPage,
      itemPerPage,
      callback
    );
  }

  loadApprovedRequestData(
    year,
    month,
    day,
    searchBy,
    query,
    activePage,
    itemPerPage,
    is_match,
    callback
  ) {
    ReportStore.loadPurchaseOrderApprovedRequestList(
      year,
      month,
      day,
      searchBy,
      query,
      activePage * itemPerPage,
      itemPerPage,
      is_match,
      callback
    );
  }

  loadApprovedRequestDataRange(
    start,
    end,
    searchBy,
    query,
    activePage,
    itemPerPage,
    callback
  ) {
    ReportStore.loadPurchaseOrderApprovedRequestListRange(
      start,
      end,
      searchBy,
      query,
      activePage * itemPerPage,
      itemPerPage,
      callback
    );
  }

  onStockTransactionLoad(e) {
    this.loadStockTransaction(
      e.type,
      e.year,
      e.month,
      e.record_type,
      e.start,
      this.state.length
    );
  }

  onTabsSelect(e) {
    // this.setState({activeTab:e})
    this.setState({ activeTab: e }, () => {
      if (e === 4) {
        this.setState({ showTran: true });
      } else this.setState({ showTran: false });
      // if (e===1) {
      //   if (this.poTable!==null)
      //     this.poTable.refreshTable()
      // } else if (e===6) {
      //   if (this.poWATable!==null)
      //     this.poWATable.refreshTable()
      // } else if (e===5) {
      //   this.refs.mechanicWaitPartReport.getWrappedInstance().loadData()
      // }
    });
  }

  renderCustomFooter(headerTitles, e) {
    let { messages } = this.props;
    let sum = 0;
    e.forEach(function (item, index) {
      let amount = item.amount;
      if (
        amount === "" ||
        amount === null ||
        amount === undefined ||
        isNaN(amount)
      )
        amount = 0;

      sum += parseFloat(amount);
    });
    return (
      <tfoot>
        <tr>
          {headerTitles.map((item, index) => {
            return (
              <th
                className={
                  item.title === "มูลค่า(บาท)" ? "text-right" : "text-center"
                }
                key={index}
              >
                {item.title === "มูลค่า(บาท)"
                  ? messages["Summary"] + " " + this.getNumberFormat(sum)
                  : item.title}
              </th>
            );
          })}
        </tr>
      </tfoot>
    );
  }

  render() {
    let { showTable, activeTab, poNo } = this.state;
    let { messages } = this.props;
    const headerTitles = [
      { title: messages["Date"], width: "100px" },
      { title: messages["PO No"], width: "150px" },
      { title: messages["Shop"], width: "150px" },
      { title: messages["Car Registration"], width: "150px" },
      { title: messages["Brand"] },
      { title: messages["Model"] },
      { title: messages["Due Date"], width: "100px" },
      { title: messages["Value"], width: "150px" },
      { title: messages["Note"] },
      { title: messages["Status"], width: "100px" },
      { title: messages["Approved Date"], width: "120px" },
      { title: messages["Received Date"], width: "120px" },
      { title: messages["Request Date"], width: "120px" },
      { title: messages["Payment Date"], width: "150px" },
      { title: messages["Technician"], width: "150px" },
    ];
    const searchOptions = [
      {
        label: messages["PO No"],
        value: "purchase_order_no",
      },
      {
        label: messages["Worksheet No"],
        value: "work_no",
      },
      {
        label: messages["Car Registration"],
        value: "car_registration_no",
      },
      {
        label: messages["Shop"],
        value: "shop_name",
      },
      {
        label: messages["Affiliates"],
        value: "affiliates_name",
      },
      {
        label: messages["Search Part"],
        value: "item_part",
      },
    ];

    if (this.props.mode === "report") {
      return (
        <div>
          <Tabs
            style={{ display: showTable ? "block" : "none" }}
            // defaultActiveKey={1}
            activeKey={activeTab}
            animation={false}
            id="po-report-tab"
            onSelect={this.onTabsSelect.bind(this)}
          >
            {this.props.showPO && (
              <Tab eventKey={1} title={messages["PO Doc"]}>
                <div style={{ display: showTable ? "block" : "none" }}>
                  <ReportGeneralTable
                    ref="poTable"
                    docType={"purchase"}
                    title={messages["PO Table"]}
                    txtTable={false}
                    newTitle={messages["Add PO"]}
                    // show={this.state.showClose}
                    // loadOnShow={this.state.loadClose}
                    show={activeTab === 1 ? true : false}
                    callOut={activeTab === 1 ? false : true}
                    loadFirst={true}
                    loadOnShow={activeTab === 1 ? true : true}
                    docClose={this.state.docClose}
                    headerTitles={headerTitles}
                    searchOptions={searchOptions}
                    searchBy={"purchase_order_no"}
                    excludeColumn={["work_no", "vat_type", "items"]}
                    loadData={this.loadData.bind(this)}
                    loadDataRange={this.loadDataRange.bind(this)}
                    onRowSelect={this.onRowSelect.bind(this)}
                    onDocNew={this.onDocNew.bind(this)}
                    onRenderColumn={this.onRenderColumn.bind(this)}
                    customFooter={true}
                    renderCustomFooter={this.renderCustomFooter.bind(
                      this,
                      headerTitles
                    )}
                    minWidth={"1300"}
                    isMobile={this.props.isMobile}
                    mobileFieldMap={{
                      title: "shop_name",
                      amount: "amount",
                      sub_title: "purchase_order_no",
                      date: "issued_date",
                      status: "status",
                      sub_status: "",
                    }}
                    renderWorkStatus={this.renderStatus.bind(this)}
                  />
                </div>
              </Tab>
            )}
            {this.props.showPOWaiting && (
              <Tab eventKey={6} title={messages["PO Doc Pending"]}>
                <div style={{ display: showTable ? "block" : "none" }}>
                  <ReportGeneralTable
                    ref="poWATable"
                    callOut={activeTab === 6 ? false : true}
                    docType={"purchase"}
                    title={messages["PO Table"]}
                    txtTable={false}
                    newTitle={messages["Add PO"]}
                    // show={this.state.showClose}
                    // loadOnShow={this.state.loadClose}
                    show={activeTab === 6 ? true : false}
                    loadOnShow={activeTab === 6 ? true : true}
                    docClose={this.state.docClose2}
                    headerTitles={headerTitles}
                    searchOptions={searchOptions}
                    searchBy={"purchase_order_no"}
                    excludeColumn={["work_no", "vat_type"]}
                    loadData={this.loadApprovedRequestData.bind(this)}
                    loadDataRange={this.loadApprovedRequestDataRange.bind(this)}
                    onRowSelect={this.onRowSelect.bind(this)}
                    onDocNew={this.onDocNew.bind(this)}
                    onRenderColumn={this.onRenderColumn.bind(this)}
                    customFooter={true}
                    renderCustomFooter={this.renderCustomFooter.bind(
                      this,
                      headerTitles
                    )}
                    minWidth={"1300"}
                    isMobile={this.props.isMobile}
                    mobileFieldMap={{
                      title: "shop_name",
                      amount: "amount",
                      sub_title: "purchase_order_no",
                      date: "issued_date",
                      status: "status",
                      sub_status: "",
                    }}
                    renderWorkStatus={this.renderStatus.bind(this)}
                  />
                </div>
              </Tab>
            )}
            {this.props.showPRWaiting && (
              <Tab eventKey={4} title={messages["PO Doc Request"]}>
                <div style={{ display: showTable ? "block" : "none" }}>
                  <StockTransactionReport
                    // show={activeTab===4}
                    show={this.state.showTran}
                    data={this.state.data}
                    totalPage={this.state.totalPage}
                    loading={this.state.loading}
                    loadData={this.onStockTransactionLoad.bind(this)}
                    report={true}
                    onDocNew={this.onDocNew.bind(this)}
                    onPOClick={this.onPOClick.bind(this)}
                    isMobile={this.props.isMobile}
                  />
                </div>
              </Tab>
            )}
            {this.props.showMechanicWaiting && (
              <Tab eventKey={5} title={messages["Technician Request Parts"]}>
                <div style={{ display: showTable ? "block" : "none" }}>
                  <MechanicWaitPartReport
                    show={activeTab === 5 ? true : false}
                    isMobile={this.props.isMobile}
                  />
                </div>
              </Tab>
            )}
          </Tabs>
          <div style={{ display: !showTable ? "block" : "none" }}>
            <Breadcrumb>
              <Breadcrumb.Item href="#" onClick={this.onDocClose.bind(this)}>
                <FontAwesome name="table" /> {messages["PO Table"]}
              </Breadcrumb.Item>
              <Breadcrumb.Item href="#" active>
                <FontAwesome name="file-o" /> {messages["Orders"]} {poNo}
              </Breadcrumb.Item>
            </Breadcrumb>
            <PurchaseOrderDoc
              ref="poDoc"
              onClose={this.onDocClose.bind(this)}
            />
          </div>
        </div>
      );
    } else if (this.props.mode === "stock" || this.props.mode === "modal") {
      return (
        <div>
          <div style={{ display: showTable ? "block" : "none" }}>
            <ReportGeneralTable
              show={this.state.showClose}
              docType={"purchase"}
              ref="poTable"
              title={messages["PO Table"]}
              txtTable={false}
              newTitle={messages["Add PO"]}
              headerTitles={headerTitles}
              searchOptions={searchOptions}
              searchBy={
                this.props.workNo !== null &&
                this.props.workNo !== "" &&
                this.props.docType === "stock-receive"
                  ? "work_no"
                  : "purchase_order_no"
              }
              excludeColumn={["work_no", "vat_type"]}
              loadData={this.loadData.bind(this)}
              loadDataRange={this.loadDataRange.bind(this)}
              onRowSelect={this.onRowSelect.bind(this)}
              onDocNew={this.onDocNew.bind(this)}
              onRenderColumn={this.onRenderColumn.bind(this)}
              customFooter={true}
              renderCustomFooter={this.renderCustomFooter.bind(
                this,
                headerTitles
              )}
              minWidth={"1400"}
              loadOnShow={this.props.loadOnShow}
              showNewButton={this.props.showNewButton}
              showCategorySelect={this.props.showCategorySelect}
              showTextSearch={this.props.showTextSearch}
              isMobile={this.props.isMobile}
              mobileFieldMap={{
                title: "shop_name",
                amount: "amount",
                sub_title: "purchase_order_no",
                date: "issued_date",
                status: "status",
                sub_status: "",
              }}
              renderWorkStatus={this.renderStatus.bind(this)}
              autoQuery={
                this.props.workNo !== null &&
                this.props.workNo !== "" &&
                this.props.docType === "stock-receive"
                  ? this.props.workNo
                  : null
              }
            />
          </div>
          <div style={{ display: !showTable ? "block" : "none" }}>
            <Breadcrumb>
              <Breadcrumb.Item href="#" onClick={this.onDocClose.bind(this)}>
                <FontAwesome name="table" /> {messages["PO Table"]}
              </Breadcrumb.Item>
              <Breadcrumb.Item href="#" active>
                <FontAwesome name="file-o" /> {messages["Orders"]} {poNo}
              </Breadcrumb.Item>
            </Breadcrumb>
            <PurchaseOrderDoc
              ref="poDoc"
              onClose={this.onDocClose.bind(this)}
            />
          </div>
        </div>
      );
    }
  }
}

ReportPurchaseOrderPage.defaultProps = {
  mode: "report",
  loadOnShow: false,
  showNewButton: true,
  showCategorySelect: true,
  showTextSearch: true,
  initPoNo: "",
  workNo: null,
  docType: "",
  showPO: false,
  showPOWaiting: true,
  showPRWaiting: true,
  showMechanicWaiting: true,
};

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 480,
});
export default connect(
  (state) => ({ messages: state.message.view.report.ReportPurchaseOrderPage }),
  null,
  null,
  { withRef: true },
  mapSizesToProps
)(ReportPurchaseOrderPage);



// WEBPACK FOOTER //
// ./src/view/report/ReportPurchaseOrderPage.js